import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;
let socketToken: string | null = null;

const getSocketUrl = (): string => {
  const { hostname, origin, port } = window.location;
  const apiPort = process.env.REACT_APP_API_PORT || "5000";

  // If we are in local development (port 3000), target the backend on port 5000
  if (port === "3000") {
    return `http://${hostname}:${apiPort}`;
  }

  // In production (real domain), use origin (proxied via Nginx)
  return origin;
};

export const initSocket = (): Socket => {
  const token = localStorage.getItem("token");

  if (socket && socketToken !== token) {
    socket.disconnect();
    socket = null;
  }

  if (!socket) {
    const url = getSocketUrl();
    socketToken = token;
    socket = io(url, {
      transports: ["websocket", "polling"],
      auth: { token },
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity,
      timeout: 20000,
      autoConnect: true,
      withCredentials: true
    });

    socket.on("connect", () => {
      console.log("Socket connected:", socket?.id);
    });

    socket.on("disconnect", () => {
      console.log("Socket disconnected");
    });

    socket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
    });
  }
  return socket;
};

export const getSocket = (): Socket | null => {
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const trackPageView = (page: string, courseName?: string, videoName?: string, courseId?: number, videoId?: number) => {
  if (socket?.connected) {
    socket.emit("page_view", { page, courseName, videoName, courseId, videoId });
  }
};
